// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class CustomImageOptions extends Component {
  imageOptionsDropdownRef = React.createRef();

  state = { showOptionsDropdown: false };

  _toggleCustomImageOptions = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
    // attach/remove event handler
    if (!this.state.showOptionsDropdown) {
      document.addEventListener(
        "onmousedown",
        this._handleCustomImageOptionsOutsideClick,
        false,
      );
      this.props.disablePlusBtnHandler(true);
    } else {
      document.removeEventListener(
        "onmousedown",
        this._handleCustomImageOptionsOutsideClick,
        false,
      );
      this.props.disablePlusBtnHandler(false);
    }
    this.setState(prevState => ({
      showOptionsDropdown: !prevState.showOptionsDropdown,
    }));
  };

  _handleCustomImageOptionsOutsideClick = e => {
    const node = this.imageOptionsDropdownRef.current;
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleCustomImageOptions();
  };

  _getOptions = () => {
    let options = [];
    if (this.props.isImageFormField) {
      options = [
        {
          id: "edit_image_field",
          label: "Edit placeholder",
          imgSrc: null,
          icon: ["far", "edit"],
          bottomBorder: false,
          actionMethod: this.props.editImageField,
        },
        {
          id: "remove_image_field",
          label: "Remove placeholder",
          icon: ["far", "times"],
          bottomBorder: false,
          actionMethod: this.props.removeImageField,
        },
      ];
    }
    if (this.props.showJustifyButtons) {
      options = [
        {
          id: "replace_image",
          label: "Replace Image",
          icon: ["far", "images"],
          bottomBorder: false,
          actionMethod: this.props.openFileBrowser,
          data: null,
        },
        {
          id: "add_alt_text",
          label: "Add Alt-text",
          icon: ["far", "edit"],
          bottomBorder: true,
          actionMethod: this.props.addAltText,
          data: null,
        },
        {
          id: "image_align_left",
          label: "Align Left",
          icon: ["fas", "align-left"],
          bottomBorder: false,
          actionMethod: this.props.handleJustification,
          data: "flex-start",
        },
        {
          id: "image_align_center",
          label: "Align Center",
          icon: ["fas", "align-center"],
          bottomBorder: false,
          actionMethod: this.props.handleJustification,
          data: "center",
        },
        {
          id: "image_align_right",
          label: "Align Right",
          icon: ["fas", "align-right"],
          bottomBorder: false,
          actionMethod: this.props.handleJustification,
          data: "flex-end",
        },
      ];
    }
    return options;
  };

  _handleOptionRowClick = (e, actionMethod, data) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.disablePlusBtnHandler(false);
    this.setState({ showOptionsDropdown: false });
    if (data) {
      actionMethod(data, e);
    } else {
      actionMethod(e);
    }
  };

  render() {
    const imageOptions = this._getOptions();
    return (
      <div
        className={`imageoptions-container ${
          this.props.mode === "TEMPLATE" ? "template-case" : ""
        }`}
        ref={this.props.optionRef}>
        <span
          className="imageoptions-dropdown-icon"
          onMouseDown={this._toggleCustomImageOptions}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0"
          data-test="imageoptions-dropdown-icon">
          <FontAwesomeIcon icon={["far", "ellipsis-v"]} />
        </span>

        {this.state.showOptionsDropdown && (
          <div
            ref={this.imageOptionsDropdownRef}
            className="imageoptions-dropdown-wrapper">
            {imageOptions.map(option => (
              <Fragment>
                <div
                  className="imageoptions-row"
                  onMouseDown={e =>
                    this._handleOptionRowClick(
                      e,
                      option.actionMethod,
                      option.data,
                    )
                  }
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex={0}>
                  <span className=" imageoptions-action-icon-wrapper imageoptions-action-icon">
                    {option.imgSrc && (
                      <img
                        className="imageoptions-action-img"
                        src={option.imgSrc}
                        alt="Add Row Column"
                      />
                    )}
                    {option.icon && (
                      <FontAwesomeIcon
                        icon={option.icon}
                        className="image-form-field-icon"
                      />
                    )}
                  </span>
                  <span className="imageoptions-action-label">
                    {option.label}
                  </span>
                </div>
                {option.bottomBorder && <hr className="imageoptions-row-hr" />}
              </Fragment>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default CustomImageOptions;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/CustomImageOptions/CustomImageOptions.js